import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Fields,
  Action,
  MutationDeleteTagArgs,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getTagsKey } from '../../utils/keys/post.key.js'

export const useDeleteTag = (options?: {
  fields?: Fields.TagFields
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationDeleteTagArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const tagsKey = getTagsKey()

  return useMutation<Action, ClientError, MutationDeleteTagArgs>(
    variables =>
      client.mutation({
        name: 'deleteTag',
        args: {
          fields,
          variables,
        },
      }),
    {
      onMutate: () => {
        queryClient.cancelQueries(tagsKey)
      },
      onSettled: () => {
        queryClient.invalidateQueries(tagsKey)
      },
      ...useMutationOptions,
    },
  )
}
